import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.tsx';

/**
 * Las rutas que son nuestras, no del dueño de un negocio.
 *
 * `RequireAuth` mira el token y alcanza para «¿entró alguien?». No alcanza para
 * «¿es de los nuestros?»: el dueño tiene token igual.
 *
 * El 2026-09-22 el PO vio «+ Nuevo tenant» con la cuenta de su negocio.
 * Esconder el botón dejaba `/tenants/new` alcanzable escribiendo la URL: el
 * dueño llega al wizard, lo llena, y recibe un 403 del backend recién al
 * guardar. El trabajo perdido lo pone él, así que el corte va en la puerta.
 *
 * **No se gatea por rol porque no se puede.** `assignedRoles` sale vacío del
 * JWT para todos —lo llenaría el Lambda pre-token de FOLLOWUP-18, que no
 * existe—. `tenantId` sí distingue: lo escribe el alta pública al crear la
 * cuenta (`registro.ts:96`), así que un dueño siempre lo tiene y un operador
 * nuestro, que no tiene negocio propio, no.
 *
 * **Esto no es la autorización.** La autorización vive en el backend, que
 * resuelve el `UserRecord` desde DynamoDB y responde 403. Esto es que la
 * pantalla no ofrezca lo que va a ser rechazado.
 */
export function SoloOperador({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  // Al listado, no al login: su sesión está bien, esta pantalla no es para él.
  // Mandarlo al login le diría que el problema es quién es.
  if (!user || user.tenantId) return <Navigate to="/tenants" replace />;

  return <>{children}</>;
}
